// Tag for graphql format
const gql = String.raw;

const WashoutSplitItemFloatFragment = gql`
	fragment WashoutSplitItemFloat on WashoutSplitItemFloat {
		retail
		lease
		value
	}
`;

const WashoutSplitItemIntFragment = gql`
	fragment WashoutSplitItemInt on WashoutSplitItemInt {
		retail
		lease
		value
	}
`;

const DepartmentalWashoutTableItemFragment = gql`
	fragment DepartmentalWashoutTableItem on DepartmentalWashoutTableItem {
		_id
		label
		account
		units {
			...WashoutSplitItemInt
		}
		contracts {
			...WashoutSplitItemFloat
		}
		grossProfit {
			...WashoutSplitItemFloat
		}
		pvr
		subFooter
		emptyRow
		oemRow
		isDefaultPage
		groupRow
		isFooter
		icon
		page
		title
		groupId
		subgroupId
	}
	${WashoutSplitItemIntFragment}
	${WashoutSplitItemFloatFragment}
`;

const DepartmentalWashoutTableGroupFragment = gql`
	fragment DepartmentalWashoutTableGroup on DepartmentalWashoutTableGroup {
		_id
		group
		values {
			...DepartmentalWashoutTableItem
		}
	}
`;

const DepartmentalWashoutTableOEMFragment = gql`
	fragment DepartmentalWashoutTableOEM on DepartmentalWashoutTableOEM {
		_id
		oemReference
		franchises
		groups {
			...DepartmentalWashoutTableGroup
		}
		totals {
			...DepartmentalWashoutTableItem
		}
		display {
			...DepartmentalWashoutTableItem
		}
	}
	${DepartmentalWashoutTableGroupFragment}
`;

const DepartmentalWashoutTableFragment = gql`
	fragment DepartmentalWashoutTable on DepartmentalWashoutTable {
		_id
		oems {
			...DepartmentalWashoutTableOEM
		}
		totals {
			...DepartmentalWashoutTableItem
		}
		hideInWashout
	}
	${DepartmentalWashoutTableOEMFragment}
	${DepartmentalWashoutTableItemFragment}
`;

export { DepartmentalWashoutTableFragment };
